/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://8081.localport.dealer.com/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 35);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = React;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = PropTypes;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = ReactRedux;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommonTester = exports.createStore = exports.Common = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _reactRedux = __webpack_require__(2);

var _react = _interopRequireDefault(__webpack_require__(0));

var _htmlReactParser = _interopRequireDefault(__webpack_require__(31));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommonRenderProp = function CommonRenderProp(props) {
  return props.render(props.commonData);
};

CommonRenderProp.propTypes = {
  render: _propTypes.default.func.isRequired,
  commonData: _propTypes.default.shape({
    labels: _propTypes.default.shape({}).isRequired,
    sitemap: _propTypes.default.shape({}).isRequired,
    prefs: _propTypes.default.shape({}).isRequired,
    flags: _propTypes.default.shape({}).isRequired
  }).isRequired
};

var labelAsHTML = function labelAsHTML(label) {
  var Tag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _react.default.Fragment;
  var html = (0, _htmlReactParser.default)(label);
  return _react.default.createElement(Tag, null, html);
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    commonData: {
      labels: {
        has: function has(key) {
          return state.labels[key] !== undefined;
        },
        get: function get(key) {
          return state.labels[key] || key;
        },
        getKeys: function getKeys() {
          return Object.keys(state.labels);
        },
        getAll: function getAll() {
          return state.labels;
        },
        getHTML: function getHTML(key, Tag) {
          return labelAsHTML(state.labels[key] || key, Tag);
        }
      },
      sitemap: {
        has: function has(alias) {
          return state.sitemap[alias] !== undefined;
        },
        get: function get(alias) {
          return state.sitemap[alias] || null;
        },
        getAll: function getAll() {
          return state.sitemap;
        }
      },
      prefs: state.prefs,
      flags: state.flags
    }
  };
};

var Common = (0, _reactRedux.connect)(mapStateToProps, null, // mapDispatchToProps
null, // mergeProps
{
  pure: false
})(CommonRenderProp);
exports.Common = Common;

var createStore = function createStore(state) {
  return {
    subscribe: function subscribe() {},
    dispatch: function dispatch() {},
    getState: function getState() {
      return state;
    }
  };
};

exports.createStore = createStore;

var CommonTester = function CommonTester(props) {
  var store = createStore({
    flags: props.flags,
    labels: props.labels,
    sitemap: props.sitemap,
    prefs: props.prefs
  });
  return _react.default.createElement(_reactRedux.Provider, {
    store: store
  }, props.render());
};

exports.CommonTester = CommonTester;
CommonTester.propTypes = {
  render: _propTypes.default.func.isRequired,
  labels: _propTypes.default.shape({}),
  sitemap: _propTypes.default.shape({}),
  prefs: _propTypes.default.shape({}),
  flags: _propTypes.default.shape({})
};
CommonTester.defaultProps = {
  labels: {},
  sitemap: {},
  prefs: {},
  flags: {}
};

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(32);

var _reactHotLoader = __webpack_require__(25);

var _Widget = _interopRequireDefault(__webpack_require__(8));

var _store = __webpack_require__(20);

var _widgetComponents = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * WARNING: This file is owned by ws-scripts and can not be edited!
 *
 * This is the main entry point for our application when
 * executed in the browser. As such, it has some responsibilities:
 *
 * - Load server side rendered redux state
 * - Create the redux store with that state
 * - Kick off a React render bound to the redux store
 *
 * NOTE: The eslint-disable-lines are needed because this file won't lint
 * when it's in the ws-scripts repo because those files only exist in the
 * widget. It's safe because the entire application won't work if those
 * weren't really resolved. It would be really apparent quickly.
 *
 * We load our server side rendered state from an object
 * of the form:
 *
 *	window.DDC = {
 *		OSIRIS: {
 *			state: {
 *				"ws-hours": {
 *					"hours1": {STATE}
 *					"hours2": {STATE}
 *				},
 *				"ws-quick-specs": {
 *					"quick-specs1": {STATE}
 *				}
 *			}
 *		}
 *	};
 *
 * In local development, the state will be a JSON object. When
 * loaded from CMS, it will be a string, since that reduces
 * serialization overhead but still avoids string concatenation.
 */
// eslint-disable-line import/no-unresolved
var getWidgetStatesByType = function getWidgetStatesByType(widgetName) {
  if (!window.DDC || !window.DDC.OSIRIS || !window.DDC.OSIRIS.state || !window.DDC.OSIRIS.state[widgetName]) {
    return {};
  }

  return window.DDC.OSIRIS.state[widgetName];
};

var getWidgetState = function getWidgetState(widgetStates, widgetId) {
  var preloadedState = widgetStates[widgetId];

  if (typeof preloadedState === 'string') {
    preloadedState = JSON.parse(preloadedState);
  }

  return preloadedState;
};

var renderWidget = function renderWidget(WidgetComponent, renderFunc, store, widgetId) {
  renderFunc(_react.default.createElement(_reactHotLoader.AppContainer, null, (0, _widgetComponents.getWidgetComponents)(WidgetComponent, store, widgetId)), document.getElementById("".concat(widgetId, "-app-root")));
};

var widgetIdToStore = {};

var initializeWidgets = function initializeWidgets() {
  var widgetStates = getWidgetStatesByType('ws-hl-features');
  var widgetIds = Object.keys(widgetStates);
  widgetIds.forEach(function (widgetId) {
    var store = (0, _store.createStore)(getWidgetState(widgetStates, widgetId));
    widgetIdToStore[widgetId] = store;
    renderWidget(_Widget.default, _reactDom.hydrate, store, widgetId);
  });
};

if (window.DDC && window.DDC.Events && window.DDC.Events['inline-js-available']) {
  initializeWidgets();
} else {
  $(document).on('inlineJSAvailable', initializeWidgets);
}

if (false) {
  module.hot.accept('../containers/Widget', function () {
    Object.keys(widgetIdToStore).forEach(function (widgetId) {
      var store = widgetIdToStore[widgetId];

      var ReloadedWidget = require('../containers/Widget').default; // eslint-disable-line import/no-unresolved


      renderWidget(ReloadedWidget, _reactDom.render, store, widgetId);
    });
  });
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VCDA_ERROR = exports.SET_FEATURES = void 0;
// This file should only contain action type constants.
var SET_FEATURES = 'SET_FEATURES';
exports.SET_FEATURES = SET_FEATURES;
var VCDA_ERROR = 'VCDA_ERROR';
exports.VCDA_ERROR = VCDA_ERROR;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _globalConstants = __webpack_require__(9);

__webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var renderFeatures = function renderFeatures(features) {
  var topFeatures = features;
  return topFeatures.map(function (id) {
    var iconType = // featureIcons map can't use apostrophes (they're in single quote strings), so feature names use &apos; instead
    _globalConstants.featureIcons.get(id[1].toLowerCase().replace("'", '&apos;')) || 'checkmark-sm';
    var iconClasses = "ddc-icon ddc-icon-".concat(iconType, " text-muted pr-3");
    return _react.default.createElement("li", {
      className: "mb-3 d-flex align-items-center",
      key: id[0]
    }, _react.default.createElement("i", {
      className: iconClasses,
      "aria-hidden": "true"
    }), id[1]);
  });
};

var HighlightedFeatures =
/*#__PURE__*/
function (_React$Component) {
  _inherits(HighlightedFeatures, _React$Component);

  function HighlightedFeatures() {
    _classCallCheck(this, HighlightedFeatures);

    return _possibleConstructorReturn(this, _getPrototypeOf(HighlightedFeatures).apply(this, arguments));
  }

  _createClass(HighlightedFeatures, [{
    key: "render",
    value: function render() {
      var features = this.props.features;

      if (features.length === 0) {
        return null;
      }

      return _react.default.createElement("ul", {
        className: "list-unstyled line-height-condensed"
      }, renderFeatures(features));
    }
  }]);

  return HighlightedFeatures;
}(_react.default.Component);

exports.default = HighlightedFeatures;
HighlightedFeatures.propTypes = {
  features: _propTypes.default.arrayOf(_propTypes.default.array)
};
HighlightedFeatures.defaultProps = {
  features: []
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WidgetContainer = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _reactRedux = __webpack_require__(2);

var _common = __webpack_require__(3);

var _HighlightedFeatures = _interopRequireDefault(__webpack_require__(7));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var WidgetContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WidgetContainer, _React$Component);

  function WidgetContainer() {
    _classCallCheck(this, WidgetContainer);

    return _possibleConstructorReturn(this, _getPrototypeOf(WidgetContainer).apply(this, arguments));
  }

  _createClass(WidgetContainer, [{
    key: "render",
    value: function render() {
      var featureArray = this.props.features;
      var featureCount = featureArray.length;

      var rootComponent = _react.default.createElement(_common.Common, {
        render: function render(_ref) {
          var prefs = _ref.prefs;

          if (featureCount > prefs.maxHighlightedFeatures) {
            featureArray.splice(prefs.maxHighlightedFeatures);
          }

          return _react.default.createElement(_HighlightedFeatures.default, {
            features: featureArray
          });
        }
      });

      return rootComponent;
    }
  }]);

  return WidgetContainer;
}(_react.default.Component);

exports.WidgetContainer = WidgetContainer;
WidgetContainer.propTypes = {
  features: _propTypes.default.arrayOf(_propTypes.default.array).isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    features: state.features
  };
};

var mapDispatchToProps = function mapDispatchToProps(_dispatch) {
  return {};
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WidgetContainer);

exports.default = _default;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.featureIcons = void 0;
// This file is intended for global constants that are shared across
// the application. Use this file sparingly. For constants with a single
// usage, it can be better to include them in the module scope of the
// file they're used in.
var featureIcons = new Map();
exports.featureIcons = featureIcons;
featureIcons.set('3rd row seats', '3rd-row-seats');
featureIcons.set('3e rangée', '3rd-row-seats');
featureIcons.set('abs brakes', 'specs-abs');
featureIcons.set('système de freinage antiblocage', 'specs-abs');
featureIcons.set('adaptive suspension', 'suspension');
featureIcons.set('alloy wheels', 'specs-wheel');
featureIcons.set('roues en alliage', 'specs-wheel');
featureIcons.set('auto dimming rear view mirror', 'auto-dimming-rear-view-mirror');
featureIcons.set('rétroviseur à atténuation automatique', 'auto-dimming-rear-view-mirror');
featureIcons.set('auto high-beam headlights', 'headlight');
featureIcons.set('auto tilt-away steering wheel', 'steeringwheel');
featureIcons.set('auto-dimming door mirrors', 'dimming-door-mirrors');
featureIcons.set('auto-leveling suspension', 'suspension');
featureIcons.set('automatic temperature control', 'automatic-temperature-control');
featureIcons.set('climatisation automatique', 'automatic-temperature-control');
featureIcons.set('blind spot sensor', 'blind-spot-sensor');
featureIcons.set('capteur d&apos;angle mort', 'blind-spot-sensor');
featureIcons.set('cd player', 'cd-player');
featureIcons.set('ceramic disc brakes', 'brakes');
featureIcons.set('chrome wheels', 'specs-wheel');
featureIcons.set('roues chromées', 'specs-wheel');
featureIcons.set('distance pacing cruise control', 'distance-pacing-cruise-control');
featureIcons.set('régulateur de vitesse adaptatif', 'distance-pacing-cruise-control');
featureIcons.set('dual rear wheels', 'specs-wheel');
featureIcons.set('roues arrière jumelées', 'specs-wheel');
featureIcons.set('electronic stability', 'traction-control');
featureIcons.set('contrôle électronique de la stabilité', 'traction-control');
featureIcons.set('emergency communication system', 'alert');
featureIcons.set('système de communication d&apos;urgence', 'alert');
featureIcons.set('entertainment system', 'entertainment-system');
featureIcons.set('système de divertissement', 'entertainment-system');
featureIcons.set('exterior parking camera front', 'backup-camera');
featureIcons.set('exterior parking camera left', 'backup-camera');
featureIcons.set('exterior parking camera rear', 'backup-camera');
featureIcons.set('exterior parking camera right', 'backup-camera');
featureIcons.set('front dual zone a/c', 'air-conditioning');
featureIcons.set('climatisation à deux zones à l&apos;avant', 'air-conditioning');
featureIcons.set('climatisation à l&apos;arrière', 'air-conditioning');
featureIcons.set('fully automatic headlights', 'headlight');
featureIcons.set('lave-phares', 'headlight');
featureIcons.set('phares entièrement automatiques', 'headlight');
featureIcons.set('headlight cleaning', 'headlight');
featureIcons.set('headphones', 'headphones');
featureIcons.set('heads up display', 'heads-up-display');
featureIcons.set('heated door mirrors', 'heated-door-mirrors');
featureIcons.set('heated front seats', 'heated-seats');
featureIcons.set('heated rear seats', 'heated-seats');
featureIcons.set('heated rear seats', 'heated-seats');
featureIcons.set('sièges avant chauffants', 'heated-seats');
featureIcons.set('heated steering wheel', 'heated-steering-wheel');
featureIcons.set('high intensity discharge headlights', 'headlight');
featureIcons.set('phares à décharge à haute intensité', 'headlight');
featureIcons.set('internet access capable', 'internet');
featureIcons.set('lane departure', 'lane-departure');
featureIcons.set('sortie de voie', 'lane-departure');
featureIcons.set('leather upholstery', 'leather-upholstery');
featureIcons.set('garniture des sièges en cuir', 'leather-upholstery');
featureIcons.set('low tire pressure warning', 'low-tire-pressure-warning');
featureIcons.set('témoin du système indicateur de pression des pneus', 'low-tire-pressure-warning');
featureIcons.set('massaging driver lumbar support', 'massaging-seat');
featureIcons.set('memory seat', 'interiorcolor');
featureIcons.set('navigation service', 'navigation-system');
featureIcons.set('navigation system', 'navigation-system');
featureIcons.set('système de navigation', 'navigation-system');
featureIcons.set('night vision lights', 'night-vision');
featureIcons.set('vision nocturne', 'night-vision');
featureIcons.set('parking sensors', 'parking-sensors');
featureIcons.set('sonar de stationnement', 'parking-sensors');
featureIcons.set('perimeter/approach lights', 'perimeter-lights');
featureIcons.set('power 2nd row moonroof', 'power-moonroof');
featureIcons.set('power 3rd row moonroof', 'power-moonroof');
featureIcons.set('power convertible roof', 'bodystyle-convertible');
featureIcons.set('power driver seat', 'interiorcolor');
featureIcons.set('siège conducteur à réglage électrique', 'interiorcolor');
featureIcons.set('power moonroof', 'power-moonroof');
featureIcons.set('toit ouvrant à commande électrique', 'power-moonroof');
featureIcons.set('power passenger seat', 'interiorcolor');
featureIcons.set('siège arrière rabattable divisé', 'interiorcolor');
featureIcons.set('premium audio system', 'premium-audio-system');
featureIcons.set('chaîne audio de qualité supérieure', 'premium-audio-system');
featureIcons.set('rain sensing wipers', 'rain-sensing-wipers');
featureIcons.set('essuie-glaces à capteur de pluie', 'rain-sensing-wipers');
featureIcons.set('rear audio controls', 'premium-audio-system');
featureIcons.set('remote keyless entry', 'remote-keyless-entry');
featureIcons.set('télédéverrouillage', 'remote-keyless-entry');
featureIcons.set('reverse sensing system', 'backup-camera');
featureIcons.set('speakers', 'speaker');
featureIcons.set('speed limit sign recognition', 'speed-limit');
featureIcons.set('speed sensitive wipers', 'speed-sensitive-wipers');
featureIcons.set('essuie-glaces sensibles à la vitesse', 'speed-sensitive-wipers');
featureIcons.set('essuie-glace de lunette', 'speed-sensitive-wipers');
featureIcons.set('steering wheel memory', 'steeringwheel');
featureIcons.set('steering wheel mounted audio controls', 'steeringwheel');
featureIcons.set('sun blinds', 'power-moonroof');
featureIcons.set('tonneau cover', 'tonneau-cover');
featureIcons.set('traction control', 'traction-control');
featureIcons.set('antipatinage', 'traction-control');
featureIcons.set('traffic sign recognition', 'traffic-sign');
featureIcons.set('trip computer', 'trip-computer');
featureIcons.set('ordinateur de voyage', 'trip-computer');
featureIcons.set('turn-by-turn navigation service', 'navigation-system');
featureIcons.set('service d&apos;orientation pas à pas', 'navigation-system');
featureIcons.set('ventilated front seats', 'seats-cooled');
featureIcons.set('ventilated rear seats', 'seats-cooled');
featureIcons.set('wireless connectivity', 'specs-bluetooth');
featureIcons.set('wireless phone connectivity', 'specs-bluetooth');
featureIcons.set('connectivité sans fil pour téléphone', 'specs-bluetooth');

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [];
exports.default = _default;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = features;

var _types = __webpack_require__(6);

function features() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    switch (action.type) {
      case _types.SET_FEATURES:
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _features = _interopRequireDefault(__webpack_require__(11));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var root = {
  features: _features.default
};
var _default = root;
exports.default = _default;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Collapse = function Collapse(props) {
  var id = props.id,
      children = props.children,
      toggleCollapse = props.toggleCollapse;

  if (toggleCollapse) {
    return _react.default.createElement("div", {
      id: "".concat(id, "-collapse"),
      className: "collapse collapse-content"
    }, children);
  }

  return children;
};

Collapse.propTypes = {
  id: _propTypes.default.string.isRequired,
  children: _propTypes.default.element.isRequired,
  toggleCollapse: _propTypes.default.bool
};
Collapse.defaultProps = {
  toggleCollapse: false
};
var _default = Collapse;
exports.default = _default;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _common = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

// eslint-disable-line import/no-unresolved
var WidgetHeading =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WidgetHeading, _React$Component);

  function WidgetHeading(props) {
    var _this;

    _classCallCheck(this, WidgetHeading);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WidgetHeading).call(this, props));
    _this.renderDelegate = _this.renderDelegate.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(WidgetHeading, [{
    key: "renderDelegate",
    value: function renderDelegate(_ref) {
      var labels = _ref.labels;
      var _this$props = this.props,
          HeadingTag = _this$props.HeadingTag,
          headingText = _this$props.headingText,
          widgetId = _this$props.widgetId,
          toggleCollapse = _this$props.toggleCollapse,
          showIcon = _this$props.showIcon,
          headingClasses = _this$props.headingClasses,
          iconClasses = _this$props.iconClasses;

      var allIconClasses = _toConsumableArray(iconClasses);

      var collapseAttributes = {};

      if (toggleCollapse) {
        var iconExpand = 'ddc-icon-expand';
        allIconClasses.push(iconExpand);
        allIconClasses.push('icon-style-collapse');
        collapseAttributes = {
          role: 'button',
          'data-toggle': 'collapse',
          'data-target': "#".concat(widgetId, "-collapse"),
          'data-expand-icon-class': "".concat(iconExpand),
          'data-collapse-icon-class': 'ddc-icon-collapse',
          'aria-expanded': 'false',
          'aria-controls': "".concat(widgetId, "-collapse")
        };
      }

      return _react.default.createElement(HeadingTag, _extends({
        className: headingClasses.join(' ')
      }, collapseAttributes), showIcon && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("i", {
        className: allIconClasses.join(' ')
      }), ' '), labels.getHTML(headingText));
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.headingText || this.props.headingText.toUpperCase() === 'FALSE') {
        return null;
      } else {
        return _react.default.createElement(_common.Common, {
          render: this.renderDelegate
        });
      }
    }
  }]);

  return WidgetHeading;
}(_react.default.Component);

WidgetHeading.propTypes = {
  HeadingTag: _propTypes.default.string,
  headingText: _propTypes.default.string,
  widgetId: _propTypes.default.string.isRequired,
  toggleCollapse: _propTypes.default.bool.isRequired,
  showIcon: _propTypes.default.bool.isRequired,
  headingClasses: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  iconClasses: _propTypes.default.arrayOf(_propTypes.default.string).isRequired
};
WidgetHeading.defaultProps = {
  HeadingTag: 'h3',
  headingText: ''
};
var _default = WidgetHeading;
exports.default = _default;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flags;

function flags() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_FEATURE_FLAGS':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = labels;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function labels() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_ADD_LABELS':
        return _objectSpread({}, state, action.payload);
      // no default
    }
  }

  return state;
}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefs;

function prefs() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_PREFS':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = requestData;

function requestData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_REQUEST_DATA':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sitemap;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function sitemap() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_ADD_SITEMAP':
        return _objectSpread({}, state, action.payload);
      // no default
    }
  }

  return state;
}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStore = createStore;

var _redux = __webpack_require__(33);

var _reduxThunk = _interopRequireDefault(__webpack_require__(34));

var _reducers = _interopRequireDefault(__webpack_require__(12));

var _requestData = _interopRequireDefault(__webpack_require__(18));

var _prefs = _interopRequireDefault(__webpack_require__(17));

var _labels = _interopRequireDefault(__webpack_require__(16));

var _sitemap = _interopRequireDefault(__webpack_require__(19));

var _flags = _interopRequireDefault(__webpack_require__(15));

var _middleware = _interopRequireDefault(__webpack_require__(10));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// eslint-disable-line import/no-unresolved
var providedReducers = {
  requestData: _requestData.default,
  prefs: _prefs.default,
  labels: _labels.default,
  sitemap: _sitemap.default,
  flags: _flags.default
};
var reducers = (0, _redux.combineReducers)(_objectSpread({}, _reducers.default, providedReducers));

var middleware = _toConsumableArray(_middleware.default).concat([_reduxThunk.default]);

var locationContains = function locationContains(search) {
  return window.location.toString().indexOf(search) !== -1;
};

var isBrowser = typeof window !== 'undefined';
var showReduxLoggerFromUrlParam = isBrowser && (locationContains('_mode=debug') || locationContains('wsScriptsUseReduxLogger=true'));

if (isBrowser && ("production" === 'development' || showReduxLoggerFromUrlParam)) {
  // Note: This must the be last middleware in the chain so that it logs actions
  // instead of thunks or Promises.
  // Use an actionTransformer to get the widget name into the output since
  // we have multiple stores running on one page. It may seem like using
  // titleFormatter makes more sense for this purpose, but doing so loses the
  // readability improvement coloring added in 2.10.0 of redux-logger. As of
  // 3.0.6, there is no way to get colors without using the default title formatter.
  // With the below action transformer and default title formatter, we get:
  // action ws-GENERIC-WIDGET-NAME - MIDDLEWARE_TEST @ 17:47:41.612 (in 0.30 ms)
  var actionTransformer = function actionTransformer(action) {
    return _objectSpread({}, action, {
      type: "ws-hl-features - ".concat(action.type)
    });
  };

  var _require = __webpack_require__(30),
      createLogger = _require.createLogger;

  var logger = createLogger({
    actionTransformer: actionTransformer,
    duration: true
  });
  middleware.push(logger);
}

var enhancer = _redux.applyMiddleware.apply(void 0, _toConsumableArray(middleware));

function createStore(initialState) {
  var store = (0, _redux.createStore)(reducers, initialState, enhancer);

  if (false) {
    module.hot.accept('../reducers', function () {
      var defaultReducers = require('../reducers').default; // eslint-disable-line import/no-unresolved


      store.replaceReducer((0, _redux.combineReducers)(_objectSpread({}, defaultReducers, providedReducers)));
    });
  }

  return store;
}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidgetComponents = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactRedux = __webpack_require__(2);

var _WidgetHeading = _interopRequireDefault(__webpack_require__(14));

var _Collapse = _interopRequireDefault(__webpack_require__(13));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getIconClasses = function getIconClasses(prefs, showIcon, toggleCollapse) {
  var iconClasses = [];
  var widgetHeading = prefs.widgetHeading,
      headingIconClasses = prefs.headingIconClasses,
      headingIconSize = prefs.headingIconSize,
      headingIconStyle = prefs.headingIconStyle;

  if (widgetHeading && showIcon) {
    iconClasses.push('ddc-icon');

    if (!toggleCollapse) {
      iconClasses.push("ddc-icon-".concat(headingIconStyle));
    }

    if (headingIconSize) {
      iconClasses.push("ddc-icon-size-".concat(headingIconSize));
    }

    if (headingIconClasses) {
      iconClasses.push(headingIconClasses);
    }
  }

  return iconClasses;
};

var getHeadingClasses = function getHeadingClasses(prefs, deviceType, toggleCollapse) {
  var headingClasses = [];
  var headingSize = prefs.headingSize,
      headingStyles = prefs.headingStyles;
  headingClasses.push('widget-heading');

  if (deviceType === 'MOBILE') {
    headingClasses.push('ddc-heading');
  }

  if (headingSize) {
    headingClasses.push(headingSize);
  }

  if (headingStyles) {
    headingClasses.push("ddc-heading-".concat(headingStyles));
  }

  if (toggleCollapse) {
    headingClasses.push('collapse-heading');
  }

  return headingClasses;
};

var getWidgetComponents = function getWidgetComponents(Widget, store, widgetId) {
  var state = store.getState();
  var prefs = state.prefs || {};
  var toggleCollapse = prefs.widgetHeading && prefs.toggleCollapse === 'true' || false;
  var showIcon = prefs.headingIconStyle ? true : toggleCollapse;
  return _react.default.createElement(_reactRedux.Provider, {
    store: store
  }, _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_WidgetHeading.default, {
    HeadingTag: prefs.headingTag,
    headingText: prefs.widgetHeading,
    widgetId: widgetId,
    toggleCollapse: toggleCollapse,
    showIcon: showIcon,
    headingClasses: getHeadingClasses(prefs, state.requestData.deviceType, toggleCollapse),
    iconClasses: getIconClasses(prefs, showIcon, toggleCollapse)
  }), _react.default.createElement(_Collapse.default, {
    id: widgetId,
    toggleCollapse: toggleCollapse
  }, _react.default.createElement(Widget, null))));
};

exports.getWidgetComponents = getWidgetComponents;

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
(function() {

/* eslint-env browser,amd,node */
//
// usertiming.js
//
// A polyfill for UserTiming (http://www.w3.org/TR/user-timing/)
//
// Copyright 2013 Nic Jansma
// http://nicj.net
//
// https://github.com/nicjansma/usertiming.js
//
// Licensed under the MIT license
//
(function(window) {
    "use strict";

    // allow running in Node.js environment
    if (typeof window === "undefined") {
        window = {};
    }

    // prepare base perf object
    if (typeof window.performance === "undefined") {
        window.performance = {};
    }

    // We need to keep a global reference to the window.performance object to
    // prevent any added properties from being garbage-collected in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137407
    window._perfRefForUserTimingPolyfill = window.performance;

    //
    // Note what we shimmed
    //
    window.performance.userTimingJsNow = false;
    window.performance.userTimingJsNowPrefixed = false;
    window.performance.userTimingJsUserTiming = false;
    window.performance.userTimingJsUserTimingPrefixed = false;
    window.performance.userTimingJsPerformanceTimeline = false;
    window.performance.userTimingJsPerformanceTimelinePrefixed = false;

    // for prefixed support
    var prefixes = [];
    var methods = [];
    var methodTest = null;
    var i, j;

    //
    // window.performance.now() shim
    //  http://www.w3.org/TR/hr-time/
    //
    if (typeof window.performance.now !== "function") {
        window.performance.userTimingJsNow = true;

        // copy prefixed version over if it exists
        methods = ["webkitNow", "msNow", "mozNow"];

        for (i = 0; i < methods.length; i++) {
            if (typeof window.performance[methods[i]] === "function") {
                window.performance.now = window.performance[methods[i]];

                window.performance.userTimingJsNowPrefixed = true;

                break;
            }
        }

        //
        // now() should be a DOMHighResTimeStamp, which is defined as being a time relative
        // to navigationStart of the PerformanceTiming (PT) interface.  If this browser supports
        // PT, use that as our relative start.  Otherwise, use "now" as the start and all other
        // now() calls will be relative to our initialization.
        //

        var nowOffset = +(new Date());
        if (window.performance.timing && window.performance.timing.navigationStart) {
            nowOffset = window.performance.timing.navigationStart;
        } else if (typeof process !== "undefined" && typeof process.hrtime === "function") {
            nowOffset = process.hrtime();
            window.performance.now = function() {
                var time = process.hrtime(nowOffset);
                return time[0] * 1e3 + time[1] * 1e-6;
            }
        }

        if (typeof window.performance.now !== "function") {
            // No browser support, fall back to Date.now
            if (Date.now) {
                window.performance.now = function() {
                    return Date.now() - nowOffset;
                };
            } else {
                // no Date.now support, get the time from new Date()
                window.performance.now = function() {
                    return +(new Date()) - nowOffset;
                };
            }
        }
    }

    //
    // PerformanceTimeline (PT) shims
    //  http://www.w3.org/TR/performance-timeline/
    //

    /**
     * Adds an object to our internal Performance Timeline array.
     *
     * Will be blank if the environment supports PT.
     */
    var addToPerformanceTimeline = function() {
    };

    /**
     * Clears the specified entry types from our timeline array.
     *
     * Will be blank if the environment supports PT.
     */
    var clearEntriesFromPerformanceTimeline = function() {
    };

    // performance timeline array
    var performanceTimeline = [];

    // whether or not the timeline will require sort on getEntries()
    var performanceTimelineRequiresSort = false;

    // whether or not ResourceTiming is natively supported but UserTiming is
    // not (eg Firefox 35)
    var hasNativeGetEntriesButNotUserTiming = false;

    //
    // If getEntries() and mark() aren't defined, we'll assume
    // we have to shim at least some PT functions.
    //
    if (typeof window.performance.getEntries !== "function" ||
        typeof window.performance.mark !== "function") {

        if (typeof window.performance.getEntries === "function" &&
            typeof window.performance.mark !== "function") {
            hasNativeGetEntriesButNotUserTiming = true;
        }

        window.performance.userTimingJsPerformanceTimeline = true;

        // copy prefixed version over if it exists
        prefixes = ["webkit", "moz"];
        methods = ["getEntries", "getEntriesByName", "getEntriesByType"];

        for (i = 0; i < methods.length; i++) {
            for (j = 0; j < prefixes.length; j++) {
                // prefixed method will likely have an upper-case first letter
                methodTest = prefixes[j] + methods[i].substr(0, 1).toUpperCase() + methods[i].substr(1);

                if (typeof window.performance[methodTest] === "function") {
                    window.performance[methods[i]] = window.performance[methodTest];

                    window.performance.userTimingJsPerformanceTimelinePrefixed = true;
                }
            }
        }

        /**
         * Adds an object to our internal Performance Timeline array.
         *
         * @param {Object} obj PerformanceEntry
         */
        addToPerformanceTimeline = function(obj) {
            performanceTimeline.push(obj);

            //
            // If we insert a measure, its startTime may be out of order
            // from the rest of the entries because the use can use any
            // mark as the start time.  If so, note we have to sort it before
            // returning getEntries();
            //
            if (obj.entryType === "measure") {
                performanceTimelineRequiresSort = true;
            }
        };

        /**
         * Ensures our PT array is in the correct sorted order (by startTime)
         */
        var ensurePerformanceTimelineOrder = function() {
            if (!performanceTimelineRequiresSort) {
                return;
            }

            //
            // Measures, which may be in this list, may enter the list in
            // an unsorted order. For example:
            //
            //  1. measure("a")
            //  2. mark("start_mark")
            //  3. measure("b", "start_mark")
            //  4. measure("c")
            //  5. getEntries()
            //
            // When calling #5, we should return [a,c,b] because technically the start time
            // of c is "0" (navigationStart), which will occur before b's start time due to the mark.
            //
            performanceTimeline.sort(function(a, b) {
                return a.startTime - b.startTime;
            });

            performanceTimelineRequiresSort = false;
        };

        /**
         * Clears the specified entry types from our timeline array.
         *
         * @param {string} entryType Entry type (eg "mark" or "measure")
         * @param {string} [name] Entry name (optional)
         */
        clearEntriesFromPerformanceTimeline = function(entryType, name) {
            // clear all entries from the perf timeline
            i = 0;
            while (i < performanceTimeline.length) {
                if (performanceTimeline[i].entryType !== entryType) {
                    // unmatched entry type
                    i++;
                    continue;
                }

                if (typeof name !== "undefined" && performanceTimeline[i].name !== name) {
                    // unmatched name
                    i++;
                    continue;
                }

                // this entry matches our criteria, remove just it
                performanceTimeline.splice(i, 1);
            }
        };

        if (typeof window.performance.getEntries !== "function" || hasNativeGetEntriesButNotUserTiming) {
            var origGetEntries = window.performance.getEntries;

            /**
             * Gets all entries from the Performance Timeline.
             * http://www.w3.org/TR/performance-timeline/#dom-performance-getentries
             *
             * NOTE: This will only ever return marks and measures.
             *
             * @returns {PerformanceEntry[]} Array of PerformanceEntrys
             */
            window.performance.getEntries = function() {
                ensurePerformanceTimelineOrder();

                // get a copy of all of our entries
                var entries = performanceTimeline.slice(0);

                // if there was a native version of getEntries, add that
                if (hasNativeGetEntriesButNotUserTiming && origGetEntries) {
                    // merge in native
                    Array.prototype.push.apply(entries, origGetEntries.call(window.performance));

                    // sort by startTime
                    entries.sort(function(a, b) {
                        return a.startTime - b.startTime;
                    });
                }

                return entries;
            };
        }

        if (typeof window.performance.getEntriesByType !== "function" || hasNativeGetEntriesButNotUserTiming) {
            var origGetEntriesByType = window.performance.getEntriesByType;

            /**
             * Gets all entries from the Performance Timeline of the specified type.
             * http://www.w3.org/TR/performance-timeline/#dom-performance-getentriesbytype
             *
             * NOTE: This will only work for marks and measures.
             *
             * @param {string} entryType Entry type (eg "mark" or "measure")
             *
             * @returns {PerformanceEntry[]} Array of PerformanceEntrys
             */
            window.performance.getEntriesByType = function(entryType) {
                // we only support marks/measures
                if (typeof entryType === "undefined" ||
                    (entryType !== "mark" && entryType !== "measure")) {

                    if (hasNativeGetEntriesButNotUserTiming && origGetEntriesByType) {
                        // native version exists, forward
                        return origGetEntriesByType.call(window.performance, entryType);
                    }

                    return [];
                }

                // see note in ensurePerformanceTimelineOrder() on why this is required
                if (entryType === "measure") {
                    ensurePerformanceTimelineOrder();
                }

                // find all entries of entryType
                var entries = [];
                for (i = 0; i < performanceTimeline.length; i++) {
                    if (performanceTimeline[i].entryType === entryType) {
                        entries.push(performanceTimeline[i]);
                    }
                }

                return entries;
            };
        }

        if (typeof window.performance.getEntriesByName !== "function" || hasNativeGetEntriesButNotUserTiming) {
            var origGetEntriesByName = window.performance.getEntriesByName;

            /**
             * Gets all entries from the Performance Timeline of the specified
             * name, and optionally, type.
             * http://www.w3.org/TR/performance-timeline/#dom-performance-getentriesbyname
             *
             * NOTE: This will only work for marks and measures.
             *
             * @param {string} name Entry name
             * @param {string} [entryType] Entry type (eg "mark" or "measure")
             *
             * @returns {PerformanceEntry[]} Array of PerformanceEntrys
             */
            window.performance.getEntriesByName = function(name, entryType) {
                if (entryType && entryType !== "mark" && entryType !== "measure") {
                    if (hasNativeGetEntriesButNotUserTiming && origGetEntriesByName) {
                        // native version exists, forward
                        return origGetEntriesByName.call(window.performance, name, entryType);
                    }

                    return [];
                }

                // see note in ensurePerformanceTimelineOrder() on why this is required
                if (typeof entryType !== "undefined" && entryType === "measure") {
                    ensurePerformanceTimelineOrder();
                }

                // find all entries of the name and (optionally) type
                var entries = [];
                for (i = 0; i < performanceTimeline.length; i++) {
                    if (typeof entryType !== "undefined" &&
                        performanceTimeline[i].entryType !== entryType) {
                        continue;
                    }

                    if (performanceTimeline[i].name === name) {
                        entries.push(performanceTimeline[i]);
                    }
                }

                if (hasNativeGetEntriesButNotUserTiming && origGetEntriesByName) {
                    // merge in native
                    Array.prototype.push.apply(entries, origGetEntriesByName.call(window.performance, name, entryType));

                    // sort by startTime
                    entries.sort(function(a, b) {
                        return a.startTime - b.startTime;
                    });
                }

                return entries;
            };
        }
    }

    //
    // UserTiming support
    //
    if (typeof window.performance.mark !== "function") {
        window.performance.userTimingJsUserTiming = true;

        // copy prefixed version over if it exists
        prefixes = ["webkit", "moz", "ms"];
        methods = ["mark", "measure", "clearMarks", "clearMeasures"];

        for (i = 0; i < methods.length; i++) {
            for (j = 0; j < prefixes.length; j++) {
                // prefixed method will likely have an upper-case first letter
                methodTest = prefixes[j] + methods[i].substr(0, 1).toUpperCase() + methods[i].substr(1);

                if (typeof window.performance[methodTest] === "function") {
                    window.performance[methods[i]] = window.performance[methodTest];

                    window.performance.userTimingJsUserTimingPrefixed = true;
                }
            }
        }

        // only used for measure(), to quickly see the latest timestamp of a mark
        var marks = {};

        if (typeof window.performance.mark !== "function") {
            /**
             * UserTiming mark
             * http://www.w3.org/TR/user-timing/#dom-performance-mark
             *
             * @param {string} markName Mark name
             */
            window.performance.mark = function(markName) {
                var now = window.performance.now();

                // mark name is required
                if (typeof markName === "undefined") {
                    throw new SyntaxError("Mark name must be specified");
                }

                // mark name can't be a NT timestamp
                if (window.performance.timing && markName in window.performance.timing) {
                    throw new SyntaxError("Mark name is not allowed");
                }

                if (!marks[markName]) {
                    marks[markName] = [];
                }

                marks[markName].push(now);

                // add to perf timeline as well
                addToPerformanceTimeline({
                    entryType: "mark",
                    name: markName,
                    startTime: now,
                    duration: 0
                });
            };
        }

        if (typeof window.performance.clearMarks !== "function") {
            /**
             * UserTiming clear marks
             * http://www.w3.org/TR/user-timing/#dom-performance-clearmarks
             *
             * @param {string} markName Mark name
             */
            window.performance.clearMarks = function(markName) {
                if (!markName) {
                    // clear all marks
                    marks = {};
                } else {
                    marks[markName] = [];
                }

                clearEntriesFromPerformanceTimeline("mark", markName);
            };
        }

        if (typeof window.performance.measure !== "function") {
            /**
             * UserTiming measure
             * http://www.w3.org/TR/user-timing/#dom-performance-measure
             *
             * @param {string} measureName Measure name
             * @param {string} [startMark] Start mark name
             * @param {string} [endMark] End mark name
             */
            window.performance.measure = function(measureName, startMark, endMark) {
                var now = window.performance.now();

                if (typeof measureName === "undefined") {
                    throw new SyntaxError("Measure must be specified");
                }

                // if there isn't a startMark, we measure from navigationStart to now
                if (!startMark) {
                    // add to perf timeline as well
                    addToPerformanceTimeline({
                        entryType: "measure",
                        name: measureName,
                        startTime: 0,
                        duration: now
                    });

                    return;
                }

                //
                // If there is a startMark, check for it first in the NavigationTiming interface,
                // then check our own marks.
                //
                var startMarkTime = 0;
                if (window.performance.timing && startMark in window.performance.timing) {
                    // mark cannot have a timing of 0
                    if (startMark !== "navigationStart" && window.performance.timing[startMark] === 0) {
                        throw new Error(startMark + " has a timing of 0");
                    }

                    // time is the offset of this mark to navigationStart's time
                    startMarkTime = window.performance.timing[startMark] - window.performance.timing.navigationStart;
                } else if (startMark in marks) {
                    startMarkTime = marks[startMark][marks[startMark].length - 1];
                } else {
                    throw new Error(startMark + " mark not found");
                }

                //
                // If there is a endMark, check for it first in the NavigationTiming interface,
                // then check our own marks.
                //
                var endMarkTime = now;

                if (endMark) {
                    endMarkTime = 0;

                    if (window.performance.timing && endMark in window.performance.timing) {
                        // mark cannot have a timing of 0
                        if (endMark !== "navigationStart" && window.performance.timing[endMark] === 0) {
                            throw new Error(endMark + " has a timing of 0");
                        }

                        // time is the offset of this mark to navigationStart's time
                        endMarkTime = window.performance.timing[endMark] - window.performance.timing.navigationStart;
                    } else if (endMark in marks) {
                        endMarkTime = marks[endMark][marks[endMark].length - 1];
                    } else {
                        throw new Error(endMark + " mark not found");
                    }
                }

                // add to our measure array
                var duration = endMarkTime - startMarkTime;

                // add to perf timeline as well
                addToPerformanceTimeline({
                    entryType: "measure",
                    name: measureName,
                    startTime: startMarkTime,
                    duration: duration
                });
            };
        }

        if (typeof window.performance.clearMeasures !== "function") {
            /**
             * UserTiming clear measures
             * http://www.w3.org/TR/user-timing/#dom-performance-clearmeasures
             *
             * @param {string} measureName Measure name
             */
            window.performance.clearMeasures = function(measureName) {
                clearEntriesFromPerformanceTimeline("measure", measureName);
            };
        }
    }

    //
    // Export UserTiming to the appropriate location.
    //
    // When included directly via a script tag in the browser, we're good as we've been
    // updating the window.performance object.
    //
    if (true) {
        //
        // AMD / RequireJS
        //
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
            return window.performance;
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module !== "undefined" && typeof module.exports !== "undefined") {
        //
        // Node.js
        //
        module.exports = window.performance;
    }
}(typeof window !== "undefined" ? window : undefined));


/*** EXPORTS FROM exports-loader ***/
module.exports = global.performance;
}.call(global));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24), __webpack_require__(4)))

/***/ }),
/* 24 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(28)


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(27);
} else {
  module.exports = require('./AppContainer.dev');
}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */

var React = __webpack_require__(0);

var Component = React.Component;

var AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer() {
    _classCallCheck(this, AppContainer);

    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
  }

  _createClass(AppContainer, [{
    key: 'render',
    value: function render() {
      if (this.props.component) {
        return React.createElement(this.props.component, this.props.props);
      }

      return React.Children.only(this.props.children);
    }
  }]);

  return AppContainer;
}(Component);

module.exports = AppContainer;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(29);
} else {
  module.exports = require('./index.dev');
}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.AppContainer = __webpack_require__(26);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(performance, global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23), __webpack_require__(4)))

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = DDC.BuiltModules["html-react-parser"]["0.4.7"];

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = ReactDOM;

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = Redux;

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = ReduxThunk;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(5);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.e40f5f6a418832954bdf.js